import { useEffect } from 'react';

const API = process.env.REACT_APP_API_URL ?? 'https://back.svecha.am/api';
const VID_KEY = 'svecha_vid';
const DEV_KEY = 'svecha_no_track';

function getVid(): string {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
        v = (typeof crypto !== 'undefined' && crypto.randomUUID)
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        localStorage.setItem(VID_KEY, v);
    }
    return v;
}

// Счётчик посетителей: визит засчитывается, если человек пробыл на сайте > 5 секунд.
// Дедуп «уникальный за день» — на бэкенде по vid+дате.
// Режим разработчика: открыть svecha.am?dev=1 → этот браузер больше не считается.
export function useVisitTracker() {
    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            if (params.get('dev') === '1') {
                localStorage.setItem(DEV_KEY, '1');
            }
            if (localStorage.getItem(DEV_KEY) === '1') return;

            const vid = getVid();
            const timer = setTimeout(() => {
                if (document.visibilityState !== 'visible') return;
                fetch(`${API}/visit`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ vid }),
                    keepalive: true,
                }).catch(() => { /* визит — необязательная телеметрия */ });
            }, 5000);
            return () => clearTimeout(timer);
        } catch {
            /* localStorage/crypto недоступны — молча пропускаем */
        }
    }, []);
}
